
import React, { Component } from "react";
import ConfirmDialog from "../components/ConfirmDialog";
import { clearErrors } from "../actions/errorActions";
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';

class UserErrors extends Component {
   
    render() {
       const { t, error } = this.props;
        //const errorsList = this.props.error.map(e => (
        //    <li>{e.message}</li>
        //));
 
        if (error && error.id != null) {
            let friendlyMessage = error.showMessageToUser === true ? t(error.message) : `${t("Sorry, We ran into a problem. Please contact the system adminstrator with the following reference")}:${error.id}`;
            if (error.moduleCode === 10) // payment error 
            {
                friendlyMessage = `${t("Your credit card has been declined, please re-enter your credit card information, try another credit card, or contact your credit card provider")}`;
            } else if (error.moduleCode === 22) {
                friendlyMessage = t(error.message).replace("{}", `(${error.extraInformation})`)
            }

            return <ConfirmDialog title={t("Error")} hiddenMessage={error.message} open={true} message={friendlyMessage} yesTitle={t("OK")} onYes={() => this.props.clearErrors()} hideNo={true} key={error.id} />;
        }
        return  "";
    }
}

function mapStateToProps({  error }, ownProps) {
    return {  error, ...ownProps };
}


export default withTranslation()(connect(mapStateToProps, { clearErrors })(UserErrors));
